import { render, staticRenderFns } from "./CarrierProductFormInfo.vue?vue&type=template&id=fb44cbb6&scoped=true&"
import script from "./CarrierProductFormInfo.vue?vue&type=script&lang=ts&"
export * from "./CarrierProductFormInfo.vue?vue&type=script&lang=ts&"
import style0 from "./CarrierProductFormInfo.vue?vue&type=style&index=0&id=fb44cbb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb44cbb6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
